import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SegmentService } from '../../../../services/segments/segment-service.service';
import { builderCommands, describeRule, isCompleteRule } from '../segment-utilities';

/** What will be saved: the name and description, then each condition in words. */
@Component({
  selector: 'segment-review-card',
  standalone: true,
  imports: [],
  templateUrl: './segment-review-card.component.html',
  styleUrl: './segment-review-card.component.css',
})
export class SegmentReviewCardComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  segmentService = inject(SegmentService);

  get conditions(): string[] {
    return this.segmentService.draftRules
      .filter(isCompleteRule)
      .map((rule) => describeRule(rule.attributeName, rule.rule ?? '', (rule.values?.[0] ?? '').toString()));
  }

  /** Back to step 1 on the same page (New segment, or Edit segment for this uuid). */
  editSegmentDetails() {
    this.router.navigate(builderCommands(this.router.url, this.route.snapshot.paramMap.get('id')), {
      queryParams: { title: 'information' },
    });
  }

  editSegmentRules() {
    this.router.navigate(builderCommands(this.router.url, this.route.snapshot.paramMap.get('id')), {
      queryParams: { title: 'rule' },
    });
  }
}
